// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lc0A","left":"styles_left__1Jq7y","desktopActions":"styles_desktopActions__37h7I","title":"styles_title__16suZ"};